import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { getStaticImage } from 'utils/statics'
import { addReaction, removeReaction } from 'redux/actions/conversations/messagesAct'
import { useWindowSize } from 'hooks'
import { createRef } from 'react'
import './styles.scss'
import { I18n } from 'react-redux-i18n'
import { useDispatch } from 'react-redux'
import withChannels from 'hocs/withChannels'

import { CONFIG_BY_CHANNEL } from './constants'
import { EmojiButton, EmojiOptions } from './EmojiButtons'
import { isCurrentReaction } from './utils'

/**
 *
 * @param {*} props
 * @param {String} props.messageId
 * @param {String} props.userId
 * @param {String} props.channel
 * @param {Array} props.activeReaction
 * @returns
 */
const FeedReactions = ({ messageId, userId, channel, activeReaction }) => {
  const [config] = useState(CONFIG_BY_CHANNEL[channel])
  const [selectorCoords, setSelectorCoords] = useState(undefined)
  const [showSelector, setShowSelector] = useState(false)
  const modalPortal = document.getElementById('modal-portal')
  const [modalVisible, setModalVisible] = useState(false)
  const selectorRef = useRef(null)
  const size = useWindowSize()
  const emojiRef = createRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if(selectorRef && selectorRef.current) {
      const coords = selectorRef.current.getBoundingClientRect()
      setSelectorCoords(coords)
    }
  }, [selectorRef, size, showSelector])

  useEffect(() => {
    if (showSelector) {
      modalPortal.style.display = 'flex'
      setModalVisible(true)
    } else {
      modalPortal.style.display = 'none'
      setModalVisible(false)
    }
  }, [showSelector])


  useEffect(() => {
    if (emojiRef && emojiRef.current) {
      const emojiContainer = emojiRef.current
      const emojiCoordinates = emojiContainer.getBoundingClientRect()
      let topPosition = selectorCoords.bottom + window.scrollY - 56
      const bottomPosition = topPosition + emojiCoordinates.height
      if (bottomPosition > window.innerHeight) {
        topPosition = window.innerHeight - emojiCoordinates.height - 30
      }
      emojiContainer.style.top = `${topPosition}px`
      emojiContainer.style.left = `${selectorCoords.right - (emojiCoordinates.width/2)}px`
      modalPortal.addEventListener('click', toogleModalPortal)
    }
    return () => modalPortal.removeEventListener('click', toogleModalPortal)
  }, [emojiRef, selectorCoords])


  const onOpenEmojiPickerClick = () => {
    setShowSelector(!showSelector)
  }

  const onSelectEmoji = async (emoji) => {
    setShowSelector(false)
    try {
      // Si se pulsa sobre la misma se elimina
      if (isCurrentReaction(activeReaction, emoji)) {
        dispatch(removeReaction({ userId, messageId }))
      } else {
        // Se añade nueva reacción
        dispatch(addReaction({ userId, messageId, emoji }))
      }
    } catch (error) {
      console.error('error: ', error)
    }
  }

  const toogleModalPortal = (event) => {
    if (event.target.style.display === 'flex') {
      event.target.style.display = 'none'
      onOpenEmojiPickerClick()
    } else {
      event.target.style.display = 'flex'
    }
  }

  return (
    <>
      <div className='feed-icon-container' ref={selectorRef}>
        <img
          src={getStaticImage('/icons/icon-emoji-grey.svg')}
          alt='Emojis'
          onClick={onOpenEmojiPickerClick}
        />
      </div>
      {
        showSelector && selectorCoords && modalVisible && ReactDOM.createPortal(
          <div
            className='feed-reactions-emoji'
            ref={emojiRef}
          >
            <div
              title={I18n.t('dashboard_send_reaction')}
              className={`feed-reactions-emoji__favs ${config.containerClass || ''}`}
            >
              {
                config.emojis.map((emoji, idx) => {
                  if (emoji === 'EmojiSelector') {
                    return (
                      <EmojiOptions
                        key={idx.toString()}
                        onClick={onSelectEmoji}
                      />
                    )
                  }

                  return (
                    <EmojiButton
                      key={idx.toString()}
                      emoji={emoji}
                      onClick={onSelectEmoji}
                      isActive={isCurrentReaction(activeReaction, emoji)}
                    />
                  )
                })
              }
            </div>
          </div>,
          modalPortal
        )
      }
    </>
  )
}

export default withChannels(FeedReactions, ['instagram__instagram', 'whatsapp__whatsapp'])